export default {
  PRODUCT_REPEATER_CLASS:
    'product-grid product-grid--per-row-4 product-grid--per-row-mob-1 product-grid--per-row-mob-1',

  VEHICLE_WIDGET_COLLAPSIBLE_CLASS: 'container',
};
